import { z } from 'zod';
import { LOOK, SourceRefSchema, about, sourceOf } from '../schema_fields.ts';

// The image tile (docs/specs/image-tile.md): a still picture from a source that gives an image,
// such as the demo's garden camera; a tap shows it full screen.

export const IMAGE_FITS = ['cover', 'contain'] as const;

export const ImageOptionsSchema = z.object({
    source: sourceOf(SourceRefSchema, { gives: ['image'], label: 'Picture' }),
    // Fill: the whole tile, the picture cut at its edges, as a camera's; whole picture: all of it (IM-5).
    fit: z.enum(IMAGE_FITS).default('cover').meta({
        ...LOOK,
        ...about('Fit', 'how the picture fills the tile'),
        'x-labels': { cover: 'Fill', contain: 'Whole picture' },
    }),
});
